<template>
  <ul class="prize-list" :class="{ 'prize-list--small-display': smallDisplay }">
    <PrizeListItem
      v-for="(prize, i) in contestPrizes"
      :key="prize.title"
      :title="prize.title"
      :copy="prize.copy"
      :index="i"
      :active="activeIndex === i"
      :smallDisplay="smallDisplay"
      @click="handleItemClick(i)"
    />
  </ul>
</template>

<script>
/**
 * list of prizes
 */
import PrizeListItem from './prize-list-item';
import {
  CONTENT_PRIZE_SECTION_PRIZE_1_TITLE,
  CONTENT_PRIZE_SECTION_PRIZE_1_BODY,
  CONTENT_PRIZE_SECTION_PRIZE_2_TITLE,
  CONTENT_PRIZE_SECTION_PRIZE_2_BODY,
  CONTENT_PRIZE_SECTION_PRIZE_3_TITLE,
  CONTENT_PRIZE_SECTION_PRIZE_3_BODY,
} from '../../design-tokens/build/dictionary';

export default {
  name: 'prize-list',
  props: {
    activeIndex: { type: Number },
    smallDisplay: {
      type: Boolean
    }
  },
  components: {
    PrizeListItem,
  },
  data() {
    return {
      contestPrizes: [
        {
          title: CONTENT_PRIZE_SECTION_PRIZE_1_TITLE,
          copy: CONTENT_PRIZE_SECTION_PRIZE_1_BODY
        },
        {
          title: CONTENT_PRIZE_SECTION_PRIZE_2_TITLE,
          copy: CONTENT_PRIZE_SECTION_PRIZE_2_BODY
        },
        {
          title: CONTENT_PRIZE_SECTION_PRIZE_3_TITLE,
          copy: CONTENT_PRIZE_SECTION_PRIZE_3_BODY
        },
      ],
    };
  },
  methods: {
    handleItemClick(index) {
      this.$emit('click', index);
    }
  }
};
</script>

<style lang="scss">
.prize-list {
  padding-left: 0;
  position: relative;

  &--small-display {
    height: $size-height-prize-list-small;
  }
}
</style>
